var map = {
	"./margins_landscape_large.png": 10534,
	"./margins_landscape_small.png": 55310,
	"./margins_landscape_zero.png": 92445,
	"./margins_portrait_large.png": 42940,
	"./margins_portrait_small.png": 31776,
	"./margins_portrait_zero.png": 15779,
	"./margins_square_large.png": 17580,
	"./margins_square_small.png": 82768,
	"./margins_square_zero.png": 82387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4679;